import { Navigate } from 'react-router-dom';
import { Role } from '@bloomays-lib/types.shared';
import { useAuthStore } from '../../stores';
import CLevelPrimesDashboard from '../organisms/CLevelPrimesDashboard';

const TamMargesDashboard = () => {
  const auth = useAuthStore((state) => state.auth);
  const isSystem = auth?.user?.roles?.includes(Role.System) || false;

  if (!isSystem) {
    return <Navigate to="/forbidden/norole" replace />;
  }

  return <CLevelPrimesDashboard />;
};

export default TamMargesDashboard;
